import { create } from 'zustand';

interface ZipsStoreState {
  zipsNumber: number;
  zipsValue: string;
  nextBillingStartAt: string | null;
}

interface ZipStoreActions {
  reset: () => void;
  setZipsNumber: (zipsNumber: ZipsStoreState['zipsNumber']) => void;
  setZipsValue: (zipsValue: ZipsStoreState['zipsValue']) => void;
  setNextBillingStartAt: (nextBillingStartAt: ZipsStoreState['nextBillingStartAt']) => void;
}

const defaultValues: ZipsStoreState = {
  zipsValue: '',
  zipsNumber: 0,
  nextBillingStartAt: null,
};

export const useZipsStore = create<ZipsStoreState & { actions: ZipStoreActions }>((set) => ({
  ...defaultValues,
  actions: {
    reset: () => set(defaultValues),
    setZipsNumber: (zipsNumber) => set({ zipsNumber }),
    setZipsValue: (zipsValue) => set({ zipsValue }),
    setNextBillingStartAt: (nextBillingStartAt) => set({ nextBillingStartAt }),
  },
}));

export const useZipsValue = () => useZipsStore((state) => state.zipsValue);
export const useZipsNumber = () => useZipsStore((state) => state.zipsNumber);
export const useNextBillingStartAt = () => useZipsStore((state) => state.nextBillingStartAt);
export const useZipsActions = () => useZipsStore((state) => state.actions);
